import React, { useEffect, useState } from 'react';
import { addjobgraphland } from '../../../FeatureRedux/ProjectionReducer/JobgraphlandReducer/jobgraphland';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import { Line } from 'react-chartjs-2';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useDispatch } from 'react-redux';
import { editProjectionGraph } from '../../../FeatureRedux/ProjectionReducer/TransportProjectionReducer/editProjectionGraph';
import { GetTransportDetail } from '../../../FeatureRedux/ProjectionReducer/TransportProjectionReducer/getTransport_Projection_reducre';
ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
);

const options = {
    responsive: true,
    plugins: {
        legend: {
            display: false // This hides the legend with the blue box
        },
        title: { 
            display: true, 
            text: 'Year-wise Job Impact' 
        },
    },
};

function JobImpact_detail({ projectiondataID, locations }) {
    const [chartData, setChartData] = useState({
        labels: [],
        datasets: [
            {
                label: 'Job Impact',
                data: [],
                fill: false,
                borderColor: '#4F46E5',
                tension: 0.3,
                pointBackgroundColor: '#4F46E5',
                pointRadius: 5,
                pointHoverRadius: 7,
            },
        ],
    });
    const [showForm, setShowForm] = useState(false);
    const [newDataPoint, setNewDataPoint] = useState({ year: '', count: '' });
    const [editingIndex, setEditingIndex] = useState(null);
    const [shake, setShake] = useState(false);
    const [showDataTable, setShowDataTable] = useState(false);
    const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
    const [deleteIndex, setDeleteIndex] = useState(null);
    const dispatch = useDispatch();

    useEffect(() => {
        if (locations && locations.job_impact && Array.isArray(locations.job_impact)) {
            const yearDataMap = {};
    
            locations.job_impact.forEach(item => {
                const year = item.year.toString();
                const count = parseFloat(item.count) || 0;
    
                if (yearDataMap[year]) {
                    yearDataMap[year] += count;
                } else {
                    yearDataMap[year] = count;
                }
            });
    
            const labels = Object.keys(yearDataMap).sort();
            const data = labels.map(year => yearDataMap[year]);
    
            setChartData({
                labels,
                datasets: [
                    {
                        ...chartData.datasets[0],
                        data,
                    },
                ],
            });
        }
    }, [locations]);

    const handleAddClick = () => {
        setEditingIndex(null);
        setShowForm(true);
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setNewDataPoint(prev => ({
            ...prev,
            [name === 'value' ? 'count' : name]: value
        }));
    };

    const validateForm = () => {
        return (
            newDataPoint.year &&
            newDataPoint.count &&
            !isNaN(newDataPoint.count) &&
            !isNaN(newDataPoint.year)
        );
    };

    const handleSubmit = async (e, newDataPoint) => {
        e.preventDefault();
        // console.log(editingIndex , newDataPoint);
        // console.log(locations?.job_impact[editingIndex]);

        // GetTransportDetail
        if(editingIndex != null){
             console.log(editingIndex , newDataPoint);
        console.log(locations);
            const data = {
                projectid:projectiondataID.projectid,
                deleteid :locations?.job_impact[editingIndex]._id,
                targetname:'job_impact',
                count:newDataPoint.count
            }
         await  dispatch(editProjectionGraph({data}))
         dispatch(GetTransportDetail(projectiondataID.projectid))
        }
        // 'x-auth-token': localStorage.getItem('token'),
        // 'x-project-id':projectionid,
        // 'x-updatedata-id':deleteid,
        // 'x-target-graph':data.targetname,

        // return ;

        if (!validateForm()) {
            setShake(true);
            setTimeout(() => setShake(false), 500);
            toast.error('Please fill all fields correctly!', { position: "top-right", autoClose: 3000 });
            return;
        }

        const year = newDataPoint.year.toString();
        const value = parseFloat(newDataPoint.count);

        let updatedLabels = [...chartData.labels];
        let updatedData = [...chartData.datasets[0].data];

        if (editingIndex !== null) {
            // Editing existing data point
            updatedLabels[editingIndex] = year;
            updatedData[editingIndex] = value;
            toast.success('Data point updated successfully!', { position: "top-right", autoClose: 3000 });
        } else {
            // Adding new data point
            const yearIndex = updatedLabels.indexOf(year);
            if (yearIndex !== -1) {
                // Year already exists, add to existing value
                updatedData[yearIndex] += value;
                toast.info(`Year ${year} already exists. Value added successfully!`, { position: "top-right", autoClose: 3000 });
            } else {
                // Year doesn't exist, add new entry
                updatedLabels.push(year);
                updatedData.push(value);
                toast.success('New year and value added successfully!', { position: "top-right", autoClose: 3000 });
            }
        }

        // Sort the data by year
        const sorted = updatedLabels
            .map((label, index) => ({ year: label, count: updatedData[index] }))
            .sort((a, b) => parseInt(a.year) - parseInt(b.year));

        setChartData({
            labels: sorted.map(item => item.year),
            datasets: [
                {
                    ...chartData.datasets[0],
                    data: sorted.map(item => item.count),
                },
            ],
        });

        const apitotarget = 'jobimpact';
        dispatch(addjobgraphland({ newDataPoint, projectiondataID, apitotarget }));

        setNewDataPoint({ year: '', count: '' });
        setShowForm(false);
        setEditingIndex(null);
    };

    const handleCancel = (e) => {
        if (e.target === e.currentTarget) {
            setNewDataPoint({ year: '', count: '' });
            setShowForm(false);
            setEditingIndex(null);
        }
    };

    const handleEdit = (index) => {
        setEditingIndex(index);
        setNewDataPoint({
            year: chartData.labels[index],
            count: chartData.datasets[0].data[index]
        });
        setShowForm(true);
        setShowDataTable(false);
    };

    const handleDeleteClick = (index) => {
        setDeleteIndex(index);
        setShowDeleteConfirm(true);
    };

    const handleDeleteConfirm = (confirmed) => {
        if (confirmed) {
            const updatedLabels = chartData.labels.filter((_, i) => i !== deleteIndex);
            const updatedData = chartData.datasets[0].data.filter((_, i) => i !== deleteIndex);

            setChartData({
                labels: updatedLabels,
                datasets: [
                    {
                        ...chartData.datasets[0],
                        data: updatedData,
                    },
                ],
            });

            toast.success('Data point deleted successfully!', { position: "top-right", autoClose: 3000 });
        }
        setShowDeleteConfirm(false);
        setDeleteIndex(null);
    };

    const toggleDataTable = () => {
        setShowDataTable(!showDataTable);
    };

    return (
        <div className="max-w-2xl mx-auto p-4 relative">
            <div className="relative flex items-center mb-4">
                <h3 className="text-xl font-semibold absolute left-1/2 transform -translate-x-1/2">
                    Job Impact
                </h3>
                <div className="ml-auto flex space-x-2">
                    <button
                        onClick={toggleDataTable}
                        className="bg-gray-600 hover:bg-gray-700 text-white p-2 rounded-full transition-all"
                        title="View Data Table"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                    </button>
                    <button
                        onClick={handleAddClick}
                        className="bg-blue-500 hover:bg-blue-600 text-white p-2 rounded-full"
                        title="Add Job Impact"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                            <path fillRule="evenodd" d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z" clipRule="evenodd" />
                        </svg>
                    </button>
                </div>
            </div>

            <Line data={chartData} options={options} />

            {/* Data Table Modal */}
            {showDataTable && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 backdrop-blur-sm transition-opacity duration-300">
                    <div className="bg-gray-800 rounded-lg w-full max-w-2xl max-h-[80vh] overflow-y-auto border border-gray-700 shadow-2xl">
                        <div className="p-4 border-b border-gray-700 flex justify-between items-center">
                            <h3 className="text-lg font-semibold text-white">Job Impact Data Points</h3>
                            <button
                                onClick={toggleDataTable}
                                className="text-gray-400 hover:text-white transition-colors duration-200 p-1 rounded-full hover:bg-gray-700"
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                </svg>
                            </button>
                        </div>
                        <div className="overflow-x-auto">
                            <table className="min-w-full divide-y divide-gray-700">
                                <thead className="bg-gray-700">
                                    <tr>
                                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-300 uppercase tracking-wider">
                                            Year
                                        </th>
                                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-300 uppercase tracking-wider">
                                            Job Impact
                                        </th>
                                        <th scope="col" className="px-6 py-3 text-right text-xs font-medium text-gray-300 uppercase tracking-wider">
                                            Actions
                                        </th>
                                    </tr>
                                </thead>
                                <tbody className="bg-gray-800 divide-y divide-gray-700">
                                    {chartData.labels.map((label, index) => (
                                        <tr key={index} className="hover:bg-gray-750">
                                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-200 text-left">
                                                {label}
                                            </td>
                                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-200 text-left">
                                                {chartData.datasets[0].data[index].toLocaleString()}
                                            </td>
                                            <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                                                <div className="flex justify-end space-x-2">
                                                    <button
                                                        onClick={() => handleEdit(index)}
                                                        className="text-blue-400 hover:text-blue-300 p-1 rounded-full hover:bg-gray-700"
                                                        title="Edit"
                                                    >
                                                        <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                                                        </svg>
                                                    </button>
                                                    <button
                                                        onClick={() => handleDeleteClick(index)}
                                                        className="text-red-400 hover:text-red-300 p-1 rounded-full hover:bg-gray-700"
                                                        title="Delete"
                                                    >
                                                        <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                                                        </svg>
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            )}

            {/* Delete Confirmation Modal */}
            {showDeleteConfirm && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 backdrop-blur-sm">
                    <div className="bg-gray-800 rounded-lg p-6 w-full max-w-md border border-gray-700 shadow-2xl">
                        <div className="mb-4">
                            <h3 className="text-lg font-semibold text-white">Confirm Deletion</h3>
                            <p className="text-gray-300 mt-2">
                                Are you sure you want to delete job impact data for {chartData.labels[deleteIndex]}?
                            </p>
                        </div>
                        <div className="flex justify-end space-x-3">
                            <button
                                onClick={() => handleDeleteConfirm(false)}
                                className="px-4 py-2 border border-gray-600 rounded-lg text-sm font-medium text-white bg-transparent hover:bg-gray-700 transition-colors"
                            >
                                Cancel
                            </button>
                            <button
                                onClick={() => handleDeleteConfirm(true)}
                                className="px-4 py-2 rounded-lg text-sm font-medium text-white bg-red-600 hover:bg-red-700 transition-colors"
                            >
                                Delete
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Add/Edit Form Modal */}
            {showForm && (
                <div
                    className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 backdrop-blur-sm transition-opacity duration-300"
                    onClick={handleCancel}
                >
                    <div
                        className={`bg-gradient-to-br from-gray-800 to-gray-900 p-8 rounded-xl w-full max-w-md relative border border-gray-700 shadow-2xl transform transition-all duration-300 ${shake ? 'animate-shake' : ''}`}
                        onClick={e => e.stopPropagation()}
                    >
                        <button
                            onClick={() => setShowForm(false)}
                            className="absolute top-4 right-4 text-gray-400 hover:text-white transition-colors duration-200 p-1 rounded-full hover:bg-gray-700"
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </button>

                        <div className="mb-6 text-center">
                            <h3 className="text-2xl font-bold text-white mb-1">
                                {editingIndex !== null ? 'Edit Job Impact Data' : 'Add New Job Impact Data'}
                            </h3>
                            <p className="text-gray-400 text-sm">
                                {editingIndex !== null ? 'Update the selected data point' : 'Fill in the details to add to the chart'}
                            </p>
                        </div>

                        <form onSubmit={(e) => handleSubmit(e, newDataPoint)} className="space-y-6">

                            <div className="flex flex-col">
                                <label className="text-gray-300 text-sm font-medium mb-1 text-left">Year</label>
                                <input
                                    type="number"
                                    name="year"
                                    value={newDataPoint.year}
                                    onChange={handleInputChange}
                                    className="px-4 py-3 bg-gray-700 border border-gray-600 rounded-lg text-white focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all"
                                    placeholder="e.g., 2026"
                                />
                            </div>

                            <div className="flex flex-col">
                                <label className="text-gray-300 text-sm font-medium mb-1 text-left">Value</label>
                                <div className="relative">
                                    <input
                                        type="number"
                                        name="value"
                                        value={newDataPoint.count}
                                        onChange={handleInputChange}
                                        className="w-full px-4 py-3 bg-gray-700 border border-gray-600 rounded-lg text-white focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all appearance-none"
                                        placeholder="Enter any numeric value"
                                    />
                                    <span className="absolute right-4 top-3 text-gray-400">₹</span>
                                </div>
                            </div>

                            <div className="flex justify-end space-x-3">
                                <button
                                    type="button"
                                    onClick={() => setShowForm(false)}
                                    className="px-4 py-2 border border-gray-600 rounded-lg text-sm font-medium text-white bg-transparent hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-all"
                                >
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="px-4 py-2 rounded-lg text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-all shadow-lg hover:shadow-blue-500/30"
                                >
                                    {editingIndex !== null ? 'Update Data' : 'Add Data'}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
}

export default JobImpact_detail;

// import React, { useEffect, useState } from 'react';
// import { addjobgraphland } from '../../../FeatureRedux/ProjectionReducer/JobgraphlandReducer/jobgraphland';
// import {
//     Chart as ChartJS,
//     CategoryScale,
//     LinearScale,
//     PointElement,
//     LineElement,
//     Title,
//     Tooltip,
//     Legend,
// } from 'chart.js';
// import { Line } from 'react-chartjs-2';
// import { toast } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
// import { useDispatch } from 'react-redux';

// ChartJS.register(
//     CategoryScale,
//     LinearScale,
//     PointElement,
//     LineElement,
//     Title,
//     Tooltip,
//     Legend
// );

// const options = {
//     responsive: true,
//     plugins: {
//         legend: { position: 'top' },
//         title: { display: true, text: 'Year-wise Job Impact' },
//     },
// };

// function JobImpact_detail({ projectiondataID, locations }) {
//     const [chartData, setChartData] = useState({
//         labels: [],
//         datasets: [
//             {
//                 label: 'Job Impact',
//                 data: [],
//                 fill: false,
//                 borderColor: '#4F46E5',
//                 tension: 0.3,
//             },
//         ],
//     });
//     const [showForm, setShowForm] = useState(false);
//     const [newDataPoint, setNewDataPoint] = useState({ year: '', count: '' });
//     const [shake, setShake] = useState(false);
//     const dispatch = useDispatch();


//     //  useEffect(() => {
//     //         console.log(`thisiis locations ${JSON.stringify(locations , null , " ")}`)
//     //         if (locations?.population_trend && locations?.population_trend.length > 0) {
//     //             console.log(`inside if`)
//     //             const sortedData = locations?.population_trend
//     //                 .map(item => ({
//     //                     year: item.year?.toString(),
//     //                     count: parseFloat(item.population)
//     //                 }))
//     //                 .filter(item => item.year && !isNaN(item.count))
//     //                 .sort((a, b) => parseInt(a.year) - parseInt(b.year));
    
//     //             const updatedChartData = {
//     //                 labels: sortedData.map(item => item.year),
//     //                 datasets: [
//     //                     {
//     //                         label: 'Population',
//     //                         data: sortedData.map(item => item.count),
//     //                         fill: false,
//     //                         borderColor: '#4F46E5',
//     //                         tension: 0.3,
//     //                     },
//     //                 ],
//     //             };
    
//     //             setChartData(updatedChartData);
//     //         }
//     //     }, [locations]);

//     useEffect(() => {
//         if (locations && locations.job_impact && Array.isArray(locations.job_impact)) {
//             // Merge the data: sum counts of same year
//             const yearDataMap = {};
    
//             locations.job_impact.forEach(item => {
//                 const year = item.year.toString();
//                 const count = parseFloat(item.count) || 0;
    
//                 if (yearDataMap[year]) {
//                     yearDataMap[year] += count;
//                 } else {
//                     yearDataMap[year] = count;
//                 }
//             });
    
//             const labels = Object.keys(yearDataMap).sort();
//             const data = labels.map(year => yearDataMap[year]);
    
//             setChartData({
//                 labels,
//                 datasets: [
//                     {
//                         label: 'Job Impact',
//                         data,
//                         fill: false,
//                         borderColor: '#4F46E5',
//                         tension: 0.3,
//                     },
//                 ],
//             });
//         }
//     }, [locations]);
    

//     const handleAddClick = () => {
//         setShowForm(true);
//     };

//     const handleInputChange = (e) => {
//         const { name, value } = e.target;
//         setNewDataPoint(prev => ({
//             ...prev,
//             [name === 'value' ? 'count' : name]: value
//         }));
//     };

//     const validateForm = () => {
//         return (
//             newDataPoint.year &&
//             newDataPoint.count &&
//             !isNaN(newDataPoint.count) &&
//             !isNaN(newDataPoint.year)
//         );
//     };

//     const handleSubmit = (e) => {
//         e.preventDefault();

//         if (!validateForm()) {
//             setShake(true);
//             setTimeout(() => setShake(false), 500);
//             toast.error('Please fill all fields correctly!', { position: "top-right", autoClose: 3000 });
//             return;
//         }

//         const year = newDataPoint.year.toString();
//         const value = parseFloat(newDataPoint.count);

//         let updatedLabels = [...chartData.labels];
//         let updatedData = [...chartData.datasets[0].data];

//         const yearIndex = updatedLabels.indexOf(year);

//         if (yearIndex !== -1) {
//             // Year already exists, add to existing value
//             updatedData[yearIndex] += value;
//             toast.info(`Year ${year} already exists. Value added successfully!`, { position: "top-right", autoClose: 3000 });
//         } else {
//             // Year doesn't exist, add new entry
//             updatedLabels.push(year);
//             updatedData.push(value);
//             toast.success('New year and value added successfully!', { position: "top-right", autoClose: 3000 });
//         }

//         setChartData({
//             labels: updatedLabels,
//             datasets: [
//                 {
//                     ...chartData.datasets[0],
//                     data: updatedData,
//                 },
//             ],
//         });

//         const apitotarget = 'jobimpact';
//         dispatch(addjobgraphland({ newDataPoint, projectiondataID, apitotarget }));

//         setNewDataPoint({ year: '', count: '' });
//         setShowForm(false);
//     };

//     const handleCancel = (e) => {
//         if (e.target === e.currentTarget) {
//             setNewDataPoint({ year: '', count: '' });
//             setShowForm(false);
//         }
//     };

//     return (
//         <div className="max-w-2xl mx-auto p-4 relative">
//             <div className="relative flex items-center mb-4">
//                 <h3 className="text-xl font-semibold absolute left-1/2 transform -translate-x-1/2">
//                     Job Impact
//                 </h3>
//                 <button
//                     onClick={handleAddClick}
//                     className="ml-auto bg-blue-500 hover:bg-blue-600 text-white p-2 rounded-full"
//                     title="Add Job Impact"
//                 >
//                     <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
//                         <path fillRule="evenodd" d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z" clipRule="evenodd" />
//                     </svg>
//                 </button>
//             </div>

//             <Line data={chartData} options={options} />

//             {showForm && (
//                 <div
//                     className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 backdrop-blur-sm transition-opacity duration-300"
//                     onClick={handleCancel}
//                 >
//                     <div
//                         className={`bg-gradient-to-br from-gray-800 to-gray-900 p-8 rounded-xl w-full max-w-md relative border border-gray-700 shadow-2xl transform transition-all duration-300 ${shake ? 'animate-shake' : ''}`}
//                         onClick={e => e.stopPropagation()}
//                     >
//                         <button
//                             onClick={() => setShowForm(false)}
//                             className="absolute top-4 right-4 text-gray-400 hover:text-white transition-colors duration-200 p-1 rounded-full hover:bg-gray-700"
//                         >
//                             <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
//                             </svg>
//                         </button>

//                         <div className="mb-6 text-center">
//                             <h3 className="text-2xl font-bold text-white mb-1">Add New Data Point</h3>
//                             <p className="text-gray-400 text-sm">Fill in the details to add to the chart</p>
//                         </div>

//                         <form onSubmit={handleSubmit} className="space-y-6">
//                             <div className="flex flex-col">
//                                 <label className="text-gray-300 text-sm font-medium mb-1 text-left">Year</label>
//                                 <input
//                                     type="number"
//                                     name="year"
//                                     value={newDataPoint.year}
//                                     onChange={handleInputChange}
//                                     className="px-4 py-3 bg-gray-700 border border-gray-600 rounded-lg text-white focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all"
//                                     placeholder="e.g., 2026"
//                                 />
//                             </div>

//                             <div className="flex flex-col">
//                                 <label className="text-gray-300 text-sm font-medium mb-1 text-left">Value</label>
//                                 <div className="relative">
//                                     <input
//                                         type="number"
//                                         name="value"
//                                         value={newDataPoint.count}
//                                         onChange={handleInputChange}
//                                         className="w-full px-4 py-3 bg-gray-700 border border-gray-600 rounded-lg text-white focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all appearance-none"
//                                         placeholder="Enter any numeric value"
//                                     />
//                                     <span className="absolute right-4 top-3 text-gray-400">₹</span>
//                                 </div>
//                             </div>

//                             <div className="flex justify-end space-x-3">
//                                 <button
//                                     type="button"
//                                     onClick={() => setShowForm(false)}
//                                     className="px-4 py-2 border border-gray-600 rounded-lg text-sm font-medium text-white bg-transparent hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-all"
//                                 >
//                                     Cancel
//                                 </button>
//                                 <button
//                                     type="submit"
//                                     className="px-4 py-2 rounded-lg text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-all shadow-lg hover:shadow-blue-500/30"
//                                 >
//                                     Add Data
//                                 </button>
//                             </div>
//                         </form>
//                     </div>
//                 </div>
//             )}
//         </div>
//     );
// }

// export default JobImpact_detail;

// import React, { useState } from 'react';
// import { addjobgraphland } from '../../../FeatureRedux/ProjectionReducer/JobgraphlandReducer/jobgraphland';
// import {
//     Chart as ChartJS,
//     CategoryScale,
//     LinearScale,
//     PointElement,
//     LineElement,
//     Title,
//     Tooltip,
//     Legend,
// } from 'chart.js';
// import { Line } from 'react-chartjs-2';
// import { toast } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
// import { useDispatch } from 'react-redux';

// ChartJS.register(
//     CategoryScale,
//     LinearScale,
//     PointElement,
//     LineElement,
//     Title,
//     Tooltip,
//     Legend
// );

// const initialData = {
//     labels: ['2020', '2021', '2022', '2023', '2024', '2025'],
//     datasets: [
//         {
//             label: 'Cost Increase (₹)',
//             data: [10000, 12000, 14000, 16500, 19000, 22000],
//             fill: false,
//             borderColor: '#4F46E5',
//             tension: 0.3,
//         },
//     ],
// };

// const options = {
//     responsive: true,
//     plugins: {
//         legend: { position: 'top' },
//         title: { display: true, text: 'Year-wise Cost Increase' },
//     },
// };

// function JobImpact_detail({ projectiondataID , locations}) {
//     const [chartData, setChartData] = useState(initialData);
//     const [showForm, setShowForm] = useState(false);
//     const [newDataPoint, setNewDataPoint] = useState({
//         year: '',
//         count: ''
//     });
//     const [shake, setShake] = useState(false);
//     const dispatch = useDispatch();

//     const handleAddClick = () => {
//         setShowForm(true);
//     };


//     console.log(`this is location data ${JSON.stringify(locations)}`)

//     const handleInputChange = (e) => {
//         const { name, value } = e.target;
//         setNewDataPoint(prev => ({
//             ...prev,
//             [name === 'value' ? 'count' : name]: value
//         }));
//     };

//     const validateForm = () => {
//         return (
//             newDataPoint.year &&
//             newDataPoint.count &&
//             !isNaN(newDataPoint.count)
//         );
//     };

//     const handleSubmit = (e) => {
//         e.preventDefault();

//         if (!validateForm()) {
//             setShake(true);
//             setTimeout(() => setShake(false), 500);
//             toast.error('Please fill all fields correctly!', {
//                 position: "top-right",
//                 autoClose: 3000,
//                 hideProgressBar: false,
//                 closeOnClick: true,
//                 pauseOnHover: true,
//                 draggable: true,
//                 progress: undefined,
//             });
//             return;
//         }

//         const apitotarget = 'jobimpact';

//         // console.log("Data Point ", newDataPoint);
//         dispatch(addjobgraphland({ newDataPoint, projectiondataID, apitotarget }));

//         const newLabels = [...chartData.labels, newDataPoint.year];
//         const newDatasetData = [...chartData.datasets[0].data, parseFloat(newDataPoint.count)];

//         setChartData({
//             labels: newLabels,
//             datasets: [
//                 {
//                     ...chartData.datasets[0],
//                     data: newDatasetData
//                 }
//             ]
//         });

//         toast.success('Data point added successfully!', {
//             position: "top-right",
//             autoClose: 3000,
//             hideProgressBar: false,
//             closeOnClick: true,
//             pauseOnHover: true,
//             draggable: true,
//             progress: undefined,
//         });

//         setNewDataPoint({ year: '', count: '' });
//         setShowForm(false);
//     };

//     const handleCancel = (e) => {
//         if (e.target === e.currentTarget) {
//             setNewDataPoint({ year: '', count: '' });
//             setShowForm(false);
//         }
//     };

//     return (
//         <div className="max-w-2xl mx-auto p-4 relative">
//             <div className="relative flex items-center mb-4">
//                 <h3 className="text-xl font-semibold absolute left-1/2 transform -translate-x-1/2">
//                     Job Impact
//                 </h3>
//                 <button
//                     onClick={handleAddClick}
//                     className="ml-auto bg-blue-500 hover:bg-blue-600 text-white p-2 rounded-full"
//                     title="Add Job Impact"
//                 >
//                     <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
//                         <path fillRule="evenodd" d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z" clipRule="evenodd" />
//                     </svg>
//                 </button>
//             </div>

//             <Line data={chartData} options={options} />

//             {showForm && (
//                 <div
//                     className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 backdrop-blur-sm transition-opacity duration-300"
//                     onClick={handleCancel}
//                 >
//                     <div
//                         className={`bg-gradient-to-br from-gray-800 to-gray-900 p-8 rounded-xl w-full max-w-md relative border border-gray-700 shadow-2xl transform transition-all duration-300 ${shake ? 'animate-shake' : ''}`}
//                         onClick={e => e.stopPropagation()}
//                     >
//                         <button
//                             onClick={() => setShowForm(false)}
//                             className="absolute top-4 right-4 text-gray-400 hover:text-white transition-colors duration-200 p-1 rounded-full hover:bg-gray-700"
//                         >
//                             <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
//                             </svg>
//                         </button>

//                         <div className="mb-6 text-center">
//                             <h3 className="text-2xl font-bold text-white mb-1">Add New Data Point</h3>
//                             <p className="text-gray-400 text-sm">Fill in the details to add to the chart</p>
//                         </div>

//                         <form onSubmit={handleSubmit} className="space-y-6">
//                             <div className="flex flex-col">
//                                 <label className="text-gray-300 text-sm font-medium mb-1 text-left">Year</label>
//                                 <input
//                                     type="number"
//                                     name="year"
//                                     value={newDataPoint.year ?? ''}
//                                     onChange={handleInputChange}
//                                     className="px-4 py-3 bg-gray-700 border border-gray-600 rounded-lg text-white focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all"
//                                     placeholder="e.g., 2026"
//                                 />
//                             </div>

//                             <div className="flex flex-col">
//                                 <label className="text-gray-300 text-sm font-medium mb-1 text-left">Value</label>
//                                 <div className="relative">
//                                     <input
//                                         type="number"
//                                         name="value"
//                                         value={newDataPoint.count ?? ''}
//                                         onChange={handleInputChange}
//                                         className="w-full px-4 py-3 bg-gray-700 border border-gray-600 rounded-lg text-white focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all appearance-none"
//                                         placeholder="Enter any numeric value"
//                                     />
//                                     <span className="absolute right-4 top-3 text-gray-400">₹</span>
//                                 </div>
//                             </div>

//                             <div className="flex justify-end space-x-3">
//                                 <button
//                                     type="button"
//                                     onClick={() => setShowForm(false)}
//                                     className="px-4 py-2 border border-gray-600 rounded-lg text-sm font-medium text-white bg-transparent hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-all"
//                                 >
//                                     Cancel
//                                 </button>
//                                 <button
//                                     type="submit"
//                                     className="px-4 py-2 rounded-lg text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-all shadow-lg hover:shadow-blue-500/30"
//                                 >
//                                     Add Data
//                                 </button>
//                             </div>
//                         </form>
//                     </div>
//                 </div>
//             )}
//         </div>
//     );
// }

// export default JobImpact_detail;



